import { useEffect, useState } from 'react';

import { getNextSpinTime } from './WheelOfFortuneCountdown.utils';

interface IWheelOfFortuneCountdownProps {
  spinTime: number;
  variant?: 'default' | 'compact';
}

const WheelOfFortuneCountdown = ({ spinTime, variant = 'default' }: IWheelOfFortuneCountdownProps) => {
  const [timeLeft, setTimeLeft] = useState(spinTime);

  useEffect(() => {
    setTimeLeft(spinTime);
  }, [spinTime]);

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft((prevTime) => (prevTime > 0 ? prevTime - 1 : 0));
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  if (variant === 'compact') {
    return (
      <p className="tw-text-center tw-text-[12px] tw-font-bold tw-leading-none tw-text-white lg:tw-text-[18px]">
        Next free spin: <span className="tw-text-[#00EB8A]">{getNextSpinTime(timeLeft)}</span>
      </p>
    );
  }

  return (
    <div className="tw-mx-auto tw-text-center tw-text-2xl tw-font-semibold tw-uppercase tw-text-white md:tw-text-[28px]/[28px]">
      Next free spin available in <br />
      <span className="tw-text-green">{getNextSpinTime(timeLeft)}</span>
    </div>
  );
};

export default WheelOfFortuneCountdown;
